export default __webpack_public_path__ + "static/media/viber_image_2022-05-14_12-20-21-975.686202a3.jpg";